import React from 'react'
import type { FC } from 'react'
import { ApiErrorModel } from '@/api/error-handler';
import localStorage from '@/services/utils/localStorage.js';
import { routes } from '@/constants';
import { apiClient } from '@/api/client';

const ErrorHandler : FC = ({ children }) => {
  const apiInterceptor = (error : ApiErrorModel) => {
    switch (error.status) {
      case 401: {
        localStorage.setItem('user', null);

        window.location.replace(routes.signIn);
      }
    }

    return Promise.reject(error);
  };

  apiClient.responseInterceptor.use(undefined, apiInterceptor);

  return (<>{ children }</>);
};

export default ErrorHandler;
